import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
/**
 * Generated class for the RepmapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

declare var google;

@Component({
  selector: 'page-repmap1',
  templateUrl: 'repmap1.html',
})
export class Repmap1Page {
  @ViewChild('mapFull') mapElement: ElementRef;
  dt: any
  lat: any
  lon: any
  code: any
  reg: any
  location: any

  dt1: any
  lat1: any
  lon1: any
  code1: any
  reg1: any
  location1: any

  zoneid: any
  Map: any
  bounds = new google.maps.LatLngBounds();
  poly: any
  isinzone: false
  isinzone1: false

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
    this.dt = navParams.data.data.datetime
    this.lat = navParams.data.data.latitude
    this.lon = navParams.data.data.longitude
    this.code = navParams.data.data.code
    this.reg = navParams.data.data.reg
    this.location = navParams.data.data.location + '' != 'undefined' ? navParams.data.data.location : ''
    this.isinzone = navParams.data.isinzone
    this.isinzone1 = navParams.data.isinzone1

    this.dt1 = navParams.data.data1.datetime1
    this.lat1 = navParams.data.data1.latitude1
    this.lon1 = navParams.data.data1.longitude1
    this.location1 = navParams.data.data1.location1 + '' != 'undefined' ? navParams.data.data1.location1 : ''

    this.zoneid = navParams.data.zid
  }

  ionViewDidLoad() {
    this.initMap()
  }


  initMap() {
    //debugger
    var _that = this
    var mapOptions = {
      zoom: 15,
      maxZoom: 20,
      minZoom: 6,
    }
    this.Map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.gn._Post('/api/gn/insertgoogleuse', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), path: this.gn.crypt('rep map') }, function () {
    })





    if (this.lat + '' != '0' && this.lon + '' != '0') {
      this.bounds.extend({ lat: parseFloat(this.lat), lng: parseFloat(this.lon) });
      var myLatLng = { lat: parseFloat(this.lat), lng: parseFloat(this.lon) };
      /*done*/var marker = new google.maps.Marker({
        position: myLatLng,
        map: this.Map,
        icon: {
          url: 'assets/imgs/newpin-green.png',
          scaledSize: new google.maps.Size(38, 43),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(13, 43),
          labelOrigin: new google.maps.Point(13, 13)
        }
      });
    }
    if (this.lat1 + '' != '0' && this.lon1 + '' != '0' && this.isinzone1 + '' == 'true') {
      this.bounds.extend({ lat: parseFloat(this.lat1), lng: parseFloat(this.lon1) });
      var myLatLng1 = { lat: parseFloat(this.lat1), lng: parseFloat(this.lon1) };
      /*done*/var marker1 = new google.maps.Marker({
        position: myLatLng1,
        map: this.Map,
        icon: {
          url: 'assets/imgs/newpin-red.png',
          scaledSize: new google.maps.Size(38, 43),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(13, 43),
          labelOrigin: new google.maps.Point(13, 13)
        }
        //title: this.dic.l["descending"] + ': ' + moment(this.dt1).format(this.gn.user.TFormat)
      });
    }

    this.gn._Post('/api/gn/getonezone', { zid: this.gn.crypt(this.zoneid) }, function (_data) {
      for (var i = 0; i < _data.length; i++) {
        var _pois = _data[i].pois.split(",")
        var pp = []
        for (var j = 0; j < _pois.length; j++) {
          var tmp = _pois[j].split(' ')
          pp.push({ lon: parseFloat(tmp[1]), lat: parseFloat(tmp[0]) })
          _that.bounds.extend({ lat: parseFloat(tmp[0]), lng: parseFloat(tmp[1]) });
        }
        var _pp = []
        for (var i = 0; i < pp.length; i++) {
          _pp.push({ lat: pp[i].lat, lng: pp[i].lon })
        }
        var poly = new google.maps.Polygon({
          paths: _pp,
          strokeColor: '#ff0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#ff0000',
          fillOpacity: 0.35,
          id: _that.zoneid
        });
        poly.setMap(_that.Map)

        setTimeout(function () {
          _that.Map.fitBounds(_that.bounds);
        }, 500);
      }
    })

    this.Map.setCenter(myLatLng)

    var _content = `
        <img src='assets/imgs/pajakup.png' style="height: 20px; position:relative; float:left;"/>
        <div class="mapwindow-text" style="position:relative; float:left; padding-left: 10px; padding-top: 5px;"><b>` + moment(this.dt).format(this.gn.user.TFormat) + `</b></div>
        <br>  
    `
    if (this.location != '') {
      _content += `<div class="mapwindow-text" style="position:relative; float:left; width: 100%; max-width: 200px;">` + this.location + `</div>`
    }
    var infowindow = new google.maps.InfoWindow({
      content: _content
    });
    infowindow.open(this.Map, marker);

    var _content1 = `
        <img src='assets/imgs/pajakdown.png' style="height: 20px; position:relative; float:left;"/>
        <div class="mapwindow-text" style="position:relative; float:left; padding-left: 10px; padding-top: 5px;"><b>` + moment(this.dt1).format(this.gn.user.TFormat) + `</b></div>
        <br>
    `
    if (this.location1 != '') {
      _content1 += `<div class="mapwindow-text" style="position:relative; float:left; width: 100%; max-width: 200px;">` + this.location1 + `</div>`
    }
    var infowindow1 = new google.maps.InfoWindow({
      content: _content1
    });
    infowindow1.open(this.Map, marker1);
  }
}


// WEBPACK FOOTER //
// ./src/pages/reports/repmap1/repmap1.ts